
<div class="card text-center">
  <div class="card-header">
    {{ 'REOPENPATIENTVISIT' | translate }} / {{translate.currentLang == 'ar'? editPatVisit.fullnameAr : editPatVisit.fullnameEn}}
  </div>
  <div class="card-block">
    <div class="row">
      <div class="col-sm-10">
        <label for="notes">{{ 'NOTES' | translate }}</label>
        <textarea class="form-control" rows="4" id="notes" [(ngModel)]="editPatVisit.dischargeRemarks" name="dischargeRemarks"></textarea>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row">

        <div class="col" *ngIf="msgDataToggle">
          <btns-ctrl [paramsArr]="controlsParams" (clicked)="onClicked($event)"></btns-ctrl>
        </div>
      </div>
    </div>
  </div>
</div>



